import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Pages
const Home = React.lazy(() => import("./components/pages/Home"));
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const Homethree = React.lazy(() => import("./components/pages/Homethree"));
const Homefour = React.lazy(() => import("./components/pages/Homefour"));
const About = React.lazy(() => import("./components/pages/About"));
const Error = React.lazy(() => import("./components/pages/Error"));

const GetInvolved = React.lazy(() => import("./components/pages/GetInvolved"));
const Issues = React.lazy(() => import("./components/pages/Issues"));
const Register2Vote = React.lazy(() => import ("./components/pages/Register2Vote"));
const ConnectWithBill = React.lazy(() => import("./components/pages/ConnectWithBill"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route exact path="/" component={Homefour} />
          <Route path="/about" component={About} />
          <Route path="/get-involved" component={GetInvolved} />
          <Route path="/issues" component={Issues} />
          <Route path="/register-to-vote" component={Register2Vote} />
          <Route path="/connect-with-bill" component={ConnectWithBill} />
          <Route path="*" component={Error} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
